import axios, { AxiosResponse } from "axios";
import environment from "../config";
import ContactData from "../entities/ContactData";
import axiosUtil from "../utils/helpers/axiosUtil";

export async function SendContactMail(contactData: ContactData) {
  if (contactData) {
    try {
      const body: ContactData = {
        memberID: contactData.memberID,
        contactSubject: contactData.contactSubject,
        contactChannel: contactData.contactChannel,
        contactDescription: contactData.contactDescription,
        fundName: contactData.fundName,
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        city: contactData.city,
        street: contactData.street,
        postOfficeBox: contactData.postOfficeBox,
        zipCode: contactData.zipCode,
        email: contactData.email,
        phone: contactData.phone,
        cellPhone: contactData.cellPhone,
        attachments: contactData.attachments,
      };
      const path = environment.BASE_URL + "General/SendContactEmail";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (axiosUtil.isSuccess(res)) {
        return true;
      }
      return false;
    } catch (err) {
      console.log(err);
    }
  }
  return false;
}
